<template>
  <modal :showing="show" :large="false">
    <d-card-header class="inner-head border-bottom">
      <h6 class="inner-head__heading m-0">Motif</h6>
      <div class="closeFeature" @click="closeModal"></div>
    </d-card-header>
    <d-card-body>
      <div class="py-2 px-3">
        {{ motif }}
      </div>
    </d-card-body>
    <d-card-footer>
      <div class="d-flex justify-content-between">
        <button class="btn btn-danger" @click="closeModal">
          {{ $t("global.return") }}
        </button>
      </div>
    </d-card-footer>
  </modal>
</template>

<script>
import Modal from '../layout/Modal/Modal';

export default {
  name: 'SimpleModal',
  components: { Modal },
  props: ['motif'],
  data() {
    return {
      show: false,
    };
  },
  methods: {
    closeModal() {
      this.show = false;
    },
    openModal() {
      this.show = true;
    },
  },
};
</script>

<style scoped>
</style>
